"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { CollectionHeaderContent, CollectionHeaderContentFragment } from "@/components/collection/header/CollectionHeaderContent";
import { useCollectionBannerMedia, useCollectionBannerMediaFallback, useCollectionBannerMediaFallbackFragment, useCollectionBannerMediaFragment } from "@/components/collection/use-collection-banner-media";
import { HeroHeader } from "@/components/hero-header/HeroHeader";
import { CollectionHeaderPreviewActions } from "./CollectionHeaderPreviewActions";
import { useCollectionBannerMediaFallbackPreview, useCollectionBannerMediaPreview } from "./useCollectionBannerMediaPreview";
export const CollectionHeaderPreviewFragment = graphql(`
    fragment CollectionHeaderPreview on Collection {
      ...CollectionHeaderContent
      ...useCollectionBannerMediaFallback
      ...useCollectionBannerMedia
    }
  `, [CollectionHeaderContentFragment, useCollectionBannerMediaFallbackFragment, useCollectionBannerMediaFragment]);
export function CollectionHeaderPreview(t0) {
  const $ = _c(13);
  let collectionKey;
  let props;
  if ($[0] !== t0) {
    const {
      collection: t1,
      ref,
      ...t2
    } = t0;
    collectionKey = t1;
    props = t2;
    $[0] = t0;
    $[1] = collectionKey;
    $[2] = props;
  } else {
    collectionKey = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== collectionKey) {
    t1 = readFragment(CollectionHeaderPreviewFragment, collectionKey);
    $[3] = collectionKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const collection = t1;
  const storeMediaUrl = useCollectionBannerMediaPreview();
  const fragmentMediaUrl = useCollectionBannerMedia(collection);
  const storeBasedFallback = useCollectionBannerMediaFallbackPreview();
  const fragmentBasedFallback = useCollectionBannerMediaFallback(collection);
  const mediaUrl = storeMediaUrl || fragmentMediaUrl;
  const fallbackImageUrl = storeBasedFallback || fragmentBasedFallback;
  const t2 = mediaUrl ?? undefined;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CollectionHeaderPreviewActions />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== collection) {
    t4 = <CollectionHeaderContent collection={collection} />;
    $[6] = collection;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fallbackImageUrl || $[9] !== props || $[10] !== t2 || $[11] !== t4) {
    t5 = <HeroHeader fallbackImageUrl={fallbackImageUrl} isCollectionBanner={true} mediaUrl={t2} {...props}>{t3}{t4}</HeroHeader>;
    $[8] = fallbackImageUrl;
    $[9] = props;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}